// Shared trailing-12-month aggregation helpers for wasteData records, used by both
// the action-plan prompt (AuditFlow) and the Dashboard KPI layout.

const monthKey=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;

// 12 calendar-month keys ending at the current month, oldest first.
export function trailing12Months(refDate=new Date()){
  const out=[];
  for(let i=11;i>=0;i--){
    out.push(monthKey(new Date(refDate.getFullYear(),refDate.getMonth()-i,1)));
  }
  return out;
}

// Returns the latest YYYY-MM date string present in wasteData, or new Date() if empty.
// This anchors the trailing-12-month window to the data itself rather than today's date,
// so historical datasets (e.g. a full prior fiscal year) display correctly on the Dashboard.
export function dataAnchorDate(wasteData){
  if(!wasteData||wasteData.length===0) return new Date();
  const latest=wasteData.map(r=>r.date).filter(Boolean).sort().at(-1);
  if(!latest) return new Date();
  const [y,m]=latest.split("-").map(Number);
  return new Date(y,m-1,1);
}

export function last12MonthsRecords(wasteData,refDate=null){
  const anchor=refDate??dataAnchorDate(wasteData);
  const months=new Set(trailing12Months(anchor));
  return wasteData.filter(r=>months.has(r.date));
}

// Normalizes a record's weight to tons regardless of which unit it was recorded in,
// so records from different accounts/sources can be combined. Null when neither is set.
export function tonsOf(record){
  if(record.weightTons!=null) return record.weightTons;
  if(record.weightLbs!=null) return record.weightLbs/2000;
  return null;
}
